import { useMemo, useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect.js';
export const noop = () => { };
const defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
const useMeasureInner = () => {
    const [element, ref] = useState(null);
    const [rect, setRect] = useState(defaultState);
    const observer = useMemo(() => new window.ResizeObserver(entries => {
        if (entries[0]) {
            const { x, y, width, height, top, left, bottom, right } = entries[0].contentRect;
            setRect({ x, y, width, height, top, left, bottom, right });
        }
    }), []);
    useIsomorphicLayoutEffect(() => {
        if (!element) {
            return;
        }
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [element]);
    return [ref, rect];
};
export const useMeasure = typeof window !== 'undefined' && typeof window.ResizeObserver !== 'undefined'
    ? useMeasureInner
    : (() => [noop, defaultState]);
//# sourceMappingURL=useMeasure.js.map